import {checkBrandIsGenderSensitive} from "../statements/check-brand-is-gender-sensitive";

export function showGenderColsIfBrandIsGenderSensitive(warmup, context) {
    const isBrandGenderSensitive = checkBrandIsGenderSensitive(context);
    if (isBrandGenderSensitive) {
        $(warmup).find('[data-warmup-brand-gender-col]').each(function () {
            $(this).removeClass('hide');
        });
    }

    return warmup;
}
